import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import style from './style.module.css';
import { 
    setToken, setUuid, setUserPoints, setUserLevel, languages,
    setUserName, setLanguage, setUserContData, setUserChapters, 
    setMenuLabels, setMenuOpened, setUserActivityData, setCourseView, 
    setOrganization, languageParse, validLangs, enLang, setSystemLabels,
    incorrectUserOrPasswordLabel, setPhishingData, setAppVersion
  } from '../../utils/constants';

import { menuLabels, sysLabels } from '../../data/translations';
import Loader from '../../assets/images/loader.svg';
import { LoginAccount, PasswordResetRequest } from '../../services/authApi';
import { useNotification } from '../../utils/notifications';

const Login: React.FC = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const notify = useNotification()

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading,setIsLoading] = useState(true);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const [isResetPassword,setIsResetPassword] = useState(false)

  const handlePasswordResetView = () => {
    isResetPassword ? setIsResetPassword(false) : setIsResetPassword(true)
  }

  const handlePasswordReset = async () => {
      setIsLoading(true)
      setIsLoggingIn(true)

      const response = await PasswordResetRequest({ email: username })
        
      setIsLoading(false)
      setIsLoggingIn(false)
      handlePasswordResetView()
      notify("Request Sent", 3000)
    
  }

  const handleLogin = async () => {
    setIsLoading(true)
    setIsLoggingIn(true)
    try {
      const response = await LoginAccount({username,password})
      if(response.token === 'false')
      {
          setIsLoggingIn(false)
          setIsLoading(false)

          notify(sysLabels[incorrectUserOrPasswordLabel]['EN'], 3000, '#FF0000')
          
          return;
      }

      setToken(response.token)
      setUuid(response.uuid)

      setUserLevel(response.level ?? 1)
      setUserPoints(response.exp)

      setUserName(response.firstname,response.lastname)

      setMenuOpened("true")
      setUserContData(JSON.stringify(response.activity_chart))
      setUserChapters(JSON.stringify(response.progress))
      setMenuLabels(JSON.stringify(menuLabels))
      setSystemLabels(JSON.stringify(sysLabels))
      setUserActivityData(JSON.stringify(response.activity))
      setPhishingData(JSON.stringify(response.activity_phishing))

      setOrganization(JSON.stringify(response.organization))

      setAppVersion(process.env.REACT_APP_VERSION || "0.0.0")

      const settings: string[] = response.settings;
      const langSetting = settings.find(item => validLangs.includes(item));
      const newLanguage = languages(languageParse(langSetting || enLang))
      setLanguage(JSON.stringify(newLanguage))
    
      navigate('/')

    } catch (error) 
    {
      setIsLoggingIn(false)
      setIsLoading(false)
    }
  };

  useEffect(() => {
    setTimeout(function(){
      setIsLoading(false)
    }, 1000);
  })

  useEffect(() => {
    setCourseView("false")
  }, [])

  return (
    <div className={style.wrapper}>
      <div className={style.container}>
        <div className={style.loginContainer}>
          <div className={style.logo}></div>
          {
            isLoading || isLoggingIn ? 
              <div className={style.loader}>
                  <img src={Loader} />
              </div> :
              isResetPassword ? 
              <>
                 <input
                  type="text"
                  placeholder="Email"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className={style.loginInput}
                />

                 <button
                  onClick={handlePasswordReset}
                  disabled={isLoading}
                  className={style.loginButton}
                >
                  Reset
                </button>
                 <div className={style.password}>
                  <div className={style.passwordLink} onClick={handlePasswordResetView}>Cancel</div>
                </div>
                
              </>
              :
              <>
                <input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className={style.loginInput}
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={style.loginInput}
                />
                <button
                  onClick={handleLogin}
                  disabled={isLoading}
                  className={style.loginButton}
                >
                  Login
                </button>
                <div className={style.password}>
                  <div className={style.passwordLink} onClick={handlePasswordResetView}>Forgot Password</div>
                </div>
              </> 
          }   
        </div>
      </div>
    </div>
  );
};

export default Login;
